var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewCal(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.833a.833.833 0 100-1.666.833.833 0 000 1.666zm4.167 0a.833.833 0 100-1.666.833.833 0 000 1.666zm0-3.333a.834.834 0 100-1.667.834.834 0 000 1.667zM10 12.5a.834.834 0 100-1.668.834.834 0 000 1.668zm5.833-10H15v-.833a.833.833 0 10-1.667 0V2.5H6.667v-.833a.833.833 0 10-1.667 0V2.5h-.833a2.5 2.5 0 00-2.5 2.5v11.667a2.5 2.5 0 002.5 2.5h11.666a2.5 2.5 0 002.5-2.5V5a2.5 2.5 0 00-2.5-2.5zm.834 14.167a.833.833 0 01-.834.833H4.167a.833.833 0 01-.834-.833v-7.5h13.334v7.5zm0-9.167H3.333V5a.833.833 0 01.834-.833H5V5a.833.833 0 001.667 0v-.833h6.666V5A.833.833 0 1015 5v-.833h.833a.833.833 0 01.834.833v2.5zm-10.834 5a.834.834 0 100-1.668.834.834 0 000 1.668zm0 3.333a.833.833 0 100-1.666.833.833 0 000 1.666z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCal);
export default ForwardRef;